import axios from 'axios'
import {router} from '../routes'


export default {
    namespaced: true,
    state:{
        horaires: [],
    },
    getters: {
        horaires: (state) => {
            return state.horaires
        }
    },
    mutations: {
        setHoraires (state, horaires) {
            state.horaires = horaires
        },
    },
    actions: {
        async initHoraires(context) {
            const horaires = (await axios.get(`/api/horaires`)).data; // une seule fois, car on renvoie avec un groupBy
            context.commit('setHoraires', horaires);
        }
    },
};
